query PlatformCustomCovers(
  $page: Int
  $rowsPerPage: Int
  $filter: PlatformCustomCoversFilterInput
) {
  platformCustomCovers(page: $page, rowsPerPage: $rowsPerPage, filter: $filter) {
    nodes {
      id
      title {
        text
        color
        size
        weight
      }
      subTitle {
        text
        color
        size
        weight
      }
      buttons {
        text
        link
        variant
        disabled
      }
      buttonsColor
      buttonsSize
      brightness
      background {
        mobileImageId
        desktopImageId
        mobileVideoId
        desktopVideoId
      }
      align
      alignMobile
      verticalAlign
      verticalAlignMobile
      publishAt
      createdAt
      updatedAt
    }
    count
  }
}

